import React from 'react';
import { Drawer, DrawerBody, DrawerHeader, Link, Typography, } from '@one-thd/sui-atomic-components';
import { Returns, QRCode, BuyAgain } from '@one-thd/sui-icons';
import BarcodeItems from './BarcodeItems';
import './barcode-drawer.scss';
import BarcodeAlert from './BarcodeAlert';
import UpsBarcode from './UpsBarcode';
import { PTC_IN_STORE_REFUND_TIMING_MESSAGE, IN_STORE_REFUND_TIMING_MESSAGE, } from '../../../constants/returns';
var ViewUpsBarcodeDrawer = function (_a) {
    var displayDrawer = _a.displayDrawer, closeDrawer = _a.closeDrawer, returnLabelResponse = _a.returnLabelResponse, items = _a.items, isPTCOrder = _a.isPTCOrder;
    var isPTC = isPTCOrder === true;
    var inStoreRefundTimingMessage = isPTC
        ? PTC_IN_STORE_REFUND_TIMING_MESSAGE
        : IN_STORE_REFUND_TIMING_MESSAGE;
    var renderUpsBarcodeImgs = function () {
        var base64decode = 'data:image/png;base64,';
        var len = (returnLabelResponse === null || returnLabelResponse === void 0 ? void 0 : returnLabelResponse.length) || 0;
        return returnLabelResponse === null || returnLabelResponse === void 0 ? void 0 : returnLabelResponse.map(function (trackingNumber, index) {
            var imageSource = base64decode + trackingNumber.upsBarcodeImg;
            return (React.createElement(UpsBarcode, { key: index, imageSource: imageSource, index: index, totalLen: len }));
        });
    };
    return (React.createElement(Drawer, { onClick: function (event) {
            event.stopPropagation();
        }, open: displayDrawer, onClose: closeDrawer, position: "right", className: "drawer-z-index-fix", "data-testid": "view-barcode-drawer" },
        React.createElement(DrawerHeader, { title: "UPS Barcode", onClose: closeDrawer }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-mb-4" },
                React.createElement(Typography, { variant: "body-lg" }, "Return Items")),
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-mb-4" },
                React.createElement(BarcodeItems, { items: items })),
            React.createElement("div", { "data-testid": "barcode-imgs-size-".concat(returnLabelResponse === null || returnLabelResponse === void 0 ? void 0 : returnLabelResponse.length) }, returnLabelResponse ? renderUpsBarcodeImgs() : React.createElement(BarcodeAlert, null)),
            React.createElement("div", { className: "sui-mb-4" },
                React.createElement("hr", null)),
            React.createElement("div", { className: "sui-mb-4 sui-flex sui-gap-3" },
                React.createElement("div", { className: "sui-pt-[6px]" },
                    React.createElement(Returns, null)),
                React.createElement(Typography, null, "Pack your return items in a box.")),
            React.createElement("div", { className: "sui-mb-4 sui-flex sui-gap-3" },
                React.createElement("div", { className: "sui-pt-[6px]" },
                    React.createElement(QRCode, null)),
                React.createElement(Typography, null,
                    "Present your barcode to an associate at",
                    ' ',
                    React.createElement(Link, { href: "https://www.theupsstore.com/tools/find-a-store", target: "_blank" }, "select UPS locations"))),
            React.createElement("div", { className: "sui-flex sui-gap-3" },
                React.createElement("div", { className: "sui-pt-[6px]" },
                    React.createElement(BuyAgain, null)),
                React.createElement(Typography, null, inStoreRefundTimingMessage)))));
};
export default ViewUpsBarcodeDrawer;
